import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/(marketing)": [4,[2],[3]],
		"/(marketing)/about": [5,[2],[3]],
		"/adc-oncology": [~17],
		"/adc-oncology/[...path]": [~18],
		"/(marketing)/ai": [~6,[2],[3]],
		"/(marketing)/careers": [7,[2],[3]],
		"/(marketing)/careers/sr-data-scientist": [8,[2],[3]],
		"/(marketing)/contact": [9,[2],[3]],
		"/glp1": [~19],
		"/glp1/[...path]": [~20],
		"/(marketing)/legal-page": [10,[2],[3]],
		"/(marketing)/news": [11,[2],[3]],
		"/(marketing)/products": [12,[2],[3]],
		"/(marketing)/reports": [13,[2],[3]],
		"/(marketing)/research": [14,[2],[3]],
		"/(marketing)/sign-in": [15,[2],[3]],
		"/(marketing)/studies": [16,[2],[3]],
		"/studies/adc-oncology-revolution": [~21],
		"/studies/anti-il-23": [~22],
		"/studies/anti-vegf": [~23],
		"/studies/glp-1": [~24],
		"/studies/sglt-2": [~25]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';